export const THEME_STORAGE_KEY = "szyos-theme";
export type Theme = "light" | "dark";
